// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"54292a4b","455":"6d6d8289","977":"29f78a79"}[chunkId] + ".chunk.js";
};